/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from 'react';
import { magnify, zoomOut } from './magnify'
import { BsUpload, BsDownload } from 'react-icons/bs'
import { apiEndPoint } from '../../../config'
import { FaSpinner } from 'react-icons/fa';
const { url } = apiEndPoint;


export default function AVCInformation({ src, side, readerReadTime, imageInput, displayImage, actionperform, setEnableSubmit }) {
    // const [showuploadmodel, setShowUploadModel] = useState(false);
    const [iserror, setIsError] = useState(false);
    const [imageName, setImageName] = useState("");
    const [isLoaded, setIsLoaded] = React.useState(false);
    useEffect(() => {
        setIsLoaded(false);
        if (src) {
            if (src.split("//")[1]) {
                let name = src.split("//")[1].split("/");
                name.shift();
                setImageName(name.join("/"));
            } else {
                setImageName('mlflow/IDFC_TESTING/' + formateDate(readerReadTime) + "/" + src);
            }
        }



    }, [readerReadTime, src])

    const formateDate = (date) => {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;

        return [year, month, day].join('_');
    }

    const onErrorHandle = (e) => {
        e.target.onerror = null
        e.target.src = '/imgesML/default-placeholder.png';
        setIsError(true);
    }

    const onLoadHandle = (e) => {
        setIsLoaded(true);
        if (!e.target.src.includes("default-placeholder.png"))
            setEnableSubmit(true)
    }

    return (
        <div >
            <div className="img-magnifier-container"
                onMouseEnter={() => magnify(side, 4)}
                onMouseLeave={() => zoomOut()}
            >

                <div class="loaderImg" style={{ display: isLoaded ? "none" : "block" }} >
                        <FaSpinner icon="spinner" spin className = "spinner-img"/>
                </div>


                <img id={side} style={{ display: isLoaded ? 'block' : 'none',margin:'auto' }} src={url + '/toll/violation/download?fileName=' + encodeURIComponent(imageName)}    onLoad={onLoadHandle} onError={onErrorHandle} alt="VehcileFront" height="300px" width="280px" />
                <label htmlFor={src + "upload-images"}>
                    {actionperform && <>
                        <div className="uploadimg"
                            onMouseLeave={() => magnify(side, 4)}
                            onMouseEnter={() => zoomOut()}
                        ><BsUpload /></div>
                        <div className="downimg"
                            onMouseLeave={() => magnify(side, 4)}
                            onMouseEnter={() => zoomOut()}
                        >
                            {iserror ? <a href="#"><BsDownload /></a>
                                : <a href={url + '/toll/violation/download?fileName=' + encodeURIComponent(imageName)} download><BsDownload /></a>}
                        </div></>}
                </label>
                <input type="file" accept=".jpg, .jpeg, .png" name={src} id={src + "upload-images"} onChange={() => displayImage(side)} ref={imageInput} style={{ display: 'none' }} />
            </div>
            
        </div>
    )
}